import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { Login as LoginIcon } from "@mui/icons-material";
import Button from "../../components/common/inputs/Button";
import { colors } from "../../styles/colors";

interface SessionExpiredModalProps {
  open: boolean;
  onLogin: () => void;
}

/**
 * Blockierendes Modal für den Fall, dass der Silent-Token-Refresh endgültig
 * fehlgeschlagen ist. Bewusst nicht schließbar (kein Escape, kein Backdrop-Klick,
 * kein X-Button) – einziger Ausweg ist die erneute Anmeldung.
 */
const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
  open,
  onLogin,
}) => (
  <Dialog
    open={open}
    onClose={() => {}}
    maxWidth="xs"
    fullWidth
    slotProps={{ paper: { sx: { borderRadius: 2 } } }}
  >
    <DialogTitle>Sitzung abgelaufen</DialogTitle>
    <DialogContent>
      <Typography sx={{ color: colors.text.secondary }}>
        Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um
        fortzufahren.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Button
        variant="primary"
        startIcon={<LoginIcon />}
        onClick={onLogin}
        fullWidth
      >
        Jetzt anmelden
      </Button>
    </DialogActions>
  </Dialog>
);

export default SessionExpiredModal;
